import { gql } from '__generated__';

export default gql(`
  mutation AddReview($input: AddReviewInput!) {
    addReview(input: $input) {
      id
    }
  }
`);
